import { useEffect, useMemo, useRef } from "react";
import { readFoldersSessionCache } from "@/lib/cache/foldersSessionCache";
import { enqueueStandardFolderWarm } from "@/lib/mail/folderHeadersPrefetch";
import type { MailAccountSummary } from "@/lib/types/mail";

/** Prépare la fenêtre 50 des dossiers principaux dès que leur liste est connue. */
export function useWarmStandardFolderHeaders(
  accounts: MailAccountSummary[],
  options?: { enabled?: boolean }
): void {
  const enabled = options?.enabled !== false;
  const accountIds = useMemo(
    () => accounts.map((account) => account.id).sort((a, b) => a - b).join(","),
    [accounts]
  );
  const startedRef = useRef("");

  useEffect(() => {
    if (!enabled || accounts.length === 0) return;
    if (startedRef.current === accountIds) return;
    startedRef.current = accountIds;
    for (const account of accounts) {
      const folders = readFoldersSessionCache(account.id);
      if (!folders || folders.length < 2) continue;
      enqueueStandardFolderWarm(account.id, folders);
    }
  }, [accountIds, accounts, enabled]);
}
